import React from "react"
import styled from "styled-components"
import { useControlSwiper } from "../hooks/useControlSwiper"
import Swiper from "react-id-swiper"
import "swiper/css/swiper.css"
import Image from "./Image"
import { VideoUrls } from "../Interface"
import { color, font } from "../Util/theme"
import { swiperParams } from "../Util/index"
import Config from "../Config/index"

const { ImageFile } = Config

type Props = {
  videoUrls: VideoUrls
  isTopText?: boolean
  isBottomText?: boolean
  height: string
  onClick?: () => void
}

const VideoSwiper = ({
  videoUrls,
  isTopText,
  isBottomText,
  height,
  onClick,
}: Props) => {
  const { updateSwiper, goNext, goPrev } = useControlSwiper()

  return (
    <Root>
      {isTopText && (
        <Header>
          <HeaderText>トレーニング種目</HeaderText>
        </Header>
      )}
      <VideoSwiperContainer>
        <PrevButtonContainer>
          <PrevButton onClick={goPrev}>
            <Image filename={ImageFile.Prev} />
          </PrevButton>
        </PrevButtonContainer>

        <Swiper {...swiperParams} getSwiper={updateSwiper}>
          {videoUrls.map((url, i) => (
            <video
              src={url}
              autoPlay
              playsInline
              muted
              width="275px"
              height={height}
              loop
              key={i}
              style={{ paddingBottom: 20, zIndex: -2 }}
            />
          ))}
        </Swiper>

        <NextButtonContainer>
          <NextButton onClick={goNext}>
            <Image filename={ImageFile.Next} />
          </NextButton>
        </NextButtonContainer>
      </VideoSwiperContainer>
      {isBottomText && (
        <CloseVideoContainer onClick={onClick}>
          <CloseButtonContainer>
            <CloseButton>
              <Image filename={ImageFile.Close} />
            </CloseButton>
          </CloseButtonContainer>
          <CloseVideoText>動画を閉じる</CloseVideoText>
        </CloseVideoContainer>
      )}
    </Root>
  )
}

const Root = styled.div`
  background-color: ${color.weekBlue};
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 30px;
`
const VideoSwiperContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${color.weekBlue};
  align-items: center;
`
const Header = styled.div`
  justify-content: flex-end;
  height: 20;
  padding-top: 19px;
  padding-left: 17px;
  padding-right: 15px;
`
const HeaderText = styled.div`
  font-size: 16px;
  font-weight: 600;
`
const NextButtonContainer = styled.div`
  padding-left: 24px;
`
const NextButton = styled.div`
  width: 17px;
  height: 21px;
`
const PrevButtonContainer = styled.div`
  padding-right: 24px;
`
const PrevButton = styled.div`
  width: 17px;
  height: 21px;
`
const CloseVideoContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
`
const CloseButtonContainer = styled.div`
  padding-right: 4px;
`
const CloseButton = styled.div`
  width: 20px;
  height: 20px;
`
const CloseVideoText = styled.div`
  font-size: 14px;
  font-family: ${font.W6};
  color: ${color.beatfit};
`
export default VideoSwiper
